__turbopack_context__.v({
  "aboveLink": "styles-module-scss-module__OH4oJW__aboveLink",
  "cardToolTip": "styles-module-scss-module__OH4oJW__cardToolTip",
  "cardWrapper": "styles-module-scss-module__OH4oJW__cardWrapper",
  "clickableItem": "styles-module-scss-module__OH4oJW__clickableItem",
  "disclosureLink": "styles-module-scss-module__OH4oJW__disclosureLink",
  "etfCard": "styles-module-scss-module__OH4oJW__etfCard",
  "fundamentalItem": "styles-module-scss-module__OH4oJW__fundamentalItem",
  "fundamentalItemsWrapper": "styles-module-scss-module__OH4oJW__fundamentalItemsWrapper",
  "fundamentals": "styles-module-scss-module__OH4oJW__fundamentals",
  "infoCircleIcon": "styles-module-scss-module__OH4oJW__infoCircleIcon",
  "layoutFloating": "styles-module-scss-module__OH4oJW__layoutFloating",
  "quoteName": "styles-module-scss-module__OH4oJW__quoteName",
  "quoteOverview": "styles-module-scss-module__OH4oJW__quoteOverview",
  "quoteTooltip": "styles-module-scss-module__OH4oJW__quoteTooltip",
  "sectionTitle": "styles-module-scss-module__OH4oJW__sectionTitle",
  "stretchedLink": "styles-module-scss-module__OH4oJW__stretchedLink",
  "tickerName": "styles-module-scss-module__OH4oJW__tickerName",
});
